import requests from "./httpService";

const WebsiteSettingsServices = {
  getHomePageSetting() {
    return requests.get(`/homepage-setting`);
  },
};

export default WebsiteSettingsServices;
